<div class="w-full h-full flex items-center justify-center content-center">
  <!-- En web móvil, espacio bajo el iframe para que los botones de Mangopay no queden tapados por la barra del navegador -->
  <div *ngIf="step === 0 && !loading" [ngClass]="{ 'pb-[calc(env(safe-area-inset-bottom)+120px)]': mobileWebSpacing }">
    <div class="py-32 w-full flex flex-col gap-72 items-center justify-center content-center appear"
      *ngIf="!iframeLoaded">
      <div class="pt-[32px]"><fun-icon [name]="'wifi'"
          [style]="'w-96 h-96 stroke-[2px] stroke-eggplant-70 animate-gradientX'"></fun-icon></div>
      <p class="text-center font-sans text-h400 md:text-h600 text-eggplant-70 animate-gradientX">{{ 'SCA.VALIDATING' |
        translate }}</p>
    </div>
    <!-- allow tiene que ser estático (NG0910): con cámara en nativo y web móvil, sin ella en web de escritorio (QR) -->
    <iframe *ngIf="urlSafe && cameraInIframe" class="w-full h-full"
      [ngClass]="{ 'min-h-[720px] min-w-[350px] md:min-w-[430px]': iframeLoaded }" [src]="urlSafe" frameborder="0"
      (load)="charged($event)" #iframe allow="camera; microphone; fullscreen; autoplay" allowfullscreen webkitallowfullscreen mozallowfullscreen></iframe>
    <iframe *ngIf="urlSafe && !cameraInIframe" class="w-full h-full"
      [ngClass]="{ 'min-h-[720px] min-w-[350px] md:min-w-[430px]': iframeLoaded }" [src]="urlSafe" frameborder="0"
      (load)="charged($event)" #iframe allow="fullscreen; autoplay" allowfullscreen webkitallowfullscreen mozallowfullscreen></iframe>
  </div>

  <div *ngIf="step === 1 && !loading"
    class="py-72 w-full flex flex-col gap-12 items-center justify-center content-center appear">
    <fun-overal-message [text]="text" [image]="image" [btnList]="btnList"
      (btnEvent)="finish(); removeModal()"></fun-overal-message>
  </div>

  <fun-spinner *ngIf="loading"></fun-spinner>
</div>